export class Quizz{
    Id: number;
    DataInicio: Date;
    DataFim: Date;
    Descricao: string;
    Resumo: string;
    ExibirUsuarioLogado: boolean;
    ExibirUsuarioNaoLogado: boolean;
    ExibirTodos: boolean;
    Ativo: boolean;
    MultiplaEscolha: boolean;
    Perguntas: QuizzPerguntas[]; 
}

export class QuizzPerguntas{
    Id: number;
    Descricao: string;
    DataCadastro: Date;
    Etapa: number;
    OrdemExibicao: number;
    PesoResposta: number;
    Ativo: Boolean;
    IdAtributo: number;
    TextoLivre: Boolean;
}

export class QuizzRespostas
{
    IdQuizzPergunta: number;
    Etapa: number;
    Valor: string;
    TextoLivre: boolean;
}